function confirmDelete() {
  return window.confirm("Soll diese Aktion wirklich durchgeführt werden?");
}

export default confirmDelete;
